import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareCustomHeaders } from "../utils/baseQueryHeaders";
import {
  TranslationMemorySegmentTagRules,
  TranslationMemorySegmentTagRule,
} from "../translation/segmentFilters";
import { CreateTranslationMemorySegmentTagRulesData } from "../translation/types";

export const translationMemorySegmentTagRulesApi = createApi({
  reducerPath: "translationMemorySegmentTagRulesApi",
  tagTypes: ["list", "item"],
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/_internal/translation-memory-segment-tag-rules/",
    prepareHeaders: prepareCustomHeaders,
  }),
  endpoints: (build) => ({
    getTagRules: build.query<TranslationMemorySegmentTagRules, void>({
      query: () => "",
      providesTags: ["list"],
      transformResponse(
        response: {
          regex: string;
          id: number;
          name?: string;
        }[]
      ) {
        const rules = response.map(
          (r) =>
            new TranslationMemorySegmentTagRule(
              new RegExp(r.regex, "g"),
              r.id,
              r?.name
            )
        );
        return new TranslationMemorySegmentTagRules(rules);
      },
    }),
    createTaggingRule: build.mutation<
      TranslationMemorySegmentTagRule,
      CreateTranslationMemorySegmentTagRulesData
    >({
      query: (data) => ({
        url: "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["list"],
      transformResponse(response: {
        regex: string;
        id: number;
        name?: string;
      }) {
        return new TranslationMemorySegmentTagRule(
          new RegExp(response.regex, "g"),
          response.id,
          response?.name
        );
      },
    }),
  }),
});

export const {
  useGetTagRulesQuery,
  useCreateTaggingRuleMutation,
} = translationMemorySegmentTagRulesApi;
